<template>
  <StyledDiv marginTop="20px">
    <StyledText
      :fontSize="styled('fontSize-medium')"
      :fontFamily="styled('fontFamily-GothamMedium')"
      padding="20px 0"
      >The Team</StyledText
    >
    <StyledDiv
      flexDirection="row"
      flexWrap="wrap"
      justifyContent="space-around"
      alignItems="flex-start"
    >
      <StyledDiv
        v-for="(s, i) in teamStrings"
        :key="i"
        minHeight="600px"
        minWidth="300px"
        maxWidth="500px"
        margin="20px 5px"
        justifyContent="flex-start"
        borderRadius="5px"
        padding="10px"
        boxShadow="0px 0px 12px -9px black"
      >
        <StyledImage
          :src="s.pic"
          maxWidth="300px"
          height="unset"
          width="unset"
        />
        <StyledText padding="15px">{{ s.name }}</StyledText>
        <StyledText
          textAlign="left"
          :fontSize="styled('fontSize-tiny')"
          lineHeight="1.2"
          padding="10px"
          >{{ s.text }}</StyledText
        >
      </StyledDiv>
    </StyledDiv>
    <Bottom />
  </StyledDiv>
</template>

<script>
import { StyledDiv, StyledText, StyledImage } from "./styled";
import StyleCompiler from "./styled/StyleCompiler";
import Cathy from "./assets/images/cathy.jpg";
import Charles from "./assets/images/charles.jpg";
import Bottom from "./components/Bottom";

export default {
  components: { StyledDiv, StyledText, StyledImage, Bottom },
  data() {
    return {
      teamStrings: [
        {
          pic: Cathy,
          name: "Dr. Cathy Callow-Heusser",
          text:
            "Dr. Cathy Callow-Heusser started her career as a software engineer developing expert systems that incorporated natural language processing and machine learning. She developed expert systems to teach special educators and students with disabilities. After founding EndVision Research and Evaluation in 2003, Dr. Callow-Heusser directed the evaluation of the Bureau of Indian Education’s (BIE) Reading First program to BIE schools throughout the U.S. to improve reading instruction and student outcomes. In 2013, she worked with Academic Success for All Learners, LLC, to develop the Reading for All Learners iOS, Android, and Kindle Fire apps and the web-based Student Assessment and Monitoring (SAM) data system. Dr. Callow-Heusser has developed multimedia instruction and a wide variety of curricula (early reading, math, science, programming, multimedia development, engineering, research/evaluation), evaluated educational programs and products, and conducted efficacy studies."
        },
        {
          pic: Charles,
          name: "Charles Major",
          text:
            "Charles Major uses lean startup methods to lead development, testing, and launch of web-based and mobile apps. Charles led development of SOS Safe On Scene, SOS Safe at School and SOS Safe and Secure Safety and Incident Management Systems, currently distributed through spin-off SOS Apps, Inc. At Google, Mr. Major served as project manager for development of the Google Express courier and Express Fleet dispatcher apps. At USU’s Space Dynamics Laboratory, he led development of innovative data analysis software that incorporated human-optimized machine learning for the calibration and validation of climatology data from NOAA’s Cross-track Infrared Sounder (CrIS) weather satellite sensor, as well as a GUI-interface to more easily access and manipulate NOAA data that was widely used by MIT, Northrup-Grumman, Raytheon, and others. Charles fluently reads Greek and Latin."
        }
      ]
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style></style>
